export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGIN_LOADING = 'USER_LOGIN_LOADING'

export const USER_REGISTER_FAIL = 'USER_REGISTER_FAIL'
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS'
export const USER_REGISTER_LOADING = 'USER_REGISTER_LOADING'

export const USER_INFO_FAIL = 'USER_INFO_FAIL'
export const USER_INFO_SUCCESS = 'USER_INFO_SUCCESS'
export const USER_INFO_LOADING = 'USER_INFO_LOADING'
export const USER_LOGOUT = 'USER_LOGOUT'
